export * from './DocEditIcon';
export * from './DocEditIcon16Light';
export * from './DocEditIcon16Regular';
export * from './DocEditIcon16Solid';
export * from './DocEditIcon20Light';
export * from './DocEditIcon20Regular';
export * from './DocEditIcon20Solid';
export * from './DocEditIcon24Regular';
export * from './DocEditIcon24Solid';
export * from './DocEditIcon32Regular';
export * from './DocEditIcon64Regular';
